import {
    IonButton,
    IonButtons,
    IonContent,
    IonIcon,
    IonModal,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import React, {useState} from "react";
import PrizeMoneyTableForm from "./PrizeMoneyTableForm";
import { close } from "ionicons/icons";
import { PrizeMoneyTable } from "../../models";
import AddPrizeMoneyTableButton from "./AddPrizeMoneyTableButton";

interface _Props {
    organizationId: string
    handleNewPrizeMoneyTable: Function
}

const AddPrizeMoneyTableCard: React.FC<_Props> = ({organizationId, handleNewPrizeMoneyTable}) => {
    const [showModal, setShowModal] = useState(false);

    const handleSubmit = (prizeMoneyTable: PrizeMoneyTable) => {
        handleNewPrizeMoneyTable(prizeMoneyTable);
        setShowModal(false);
    }

    return (
        <>
            <AddPrizeMoneyTableButton onSubmit={() => setShowModal(true)} />
            <IonModal backdropDismiss={false} isOpen={showModal} id="prizeMoneyTableModal">
                <IonToolbar color="light">
                    <IonTitle className="ion-text-center">
                        Add Prize Money Table
                    </IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            fill="clear"
                            onClick={() => setShowModal(false)}
                        >
                            <p id="closePrizeMoneyTableModalBtn" className="font-weight-normal text-medium text-capitalize">
                                <IonIcon icon={close} />
                            </p>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent className="ion-padding">
                    <PrizeMoneyTableForm organizationId={organizationId} onSubmit={handleSubmit} />
                </IonContent>
            </IonModal>
        </>
    );
};

export default AddPrizeMoneyTableCard;
